module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.5591/js/img/productIcons/Sales_Starter_white.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/productIcons/Sales_Starter_white.svg
// module id = 823
// module chunks = 5 6